import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  upperContainerRoot: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: `${theme.spacing(6)}px ${theme.spacing(2)}px`,
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      paddingTop: theme.spacing(3),
      maxWidth: '1000px',
    },
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
    margin: 'auto',
  },
  upperContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: theme.spacing(4),
    alignItems: 'center',
    width: '100%',
    margin: 'auto',
  },
  upperContainerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    margin: 'auto',
  },
  upperContainerText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  textLink: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeightBold,
    cursor: 'pointer',
  },
  getStartedButton: {
    width: 'fit-content',
  },
  video: {
    maxWidth: '900px',
    width: '100%',
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      justifySelf: 'flex-end',
    },
  },
  cardRowContainer: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(4),
      padding: `0px ${theme.spacing(2)}px ${theme.spacing(6)}px ${theme.spacing(2)}px`,
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginTop: theme.spacing(2),
      justifyContent: 'space-between',
      paddingTop: theme.spacing(3),
      maxWidth: '1000px',
    },
    alignItems: 'center',
    width: '100%',
    height: 'fit-content',
    paddingBottom: theme.spacing(5),
  },
  quotationMark: {
    position: 'absolute',
    marginLeft: '20px',
    marginTop: '-14.625px',
  },
  card: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '32%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
    width: '100%',
  },
  cardContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '28px 20px 20px 20px',
    justifyContent: 'space-evenly',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '293px',
      height: '171px',
    },
  },
  cardLowerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  nameText: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
  },
  landlordText: {
    color: theme.palette.primary.light,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'uppercase',
  },
  purpleSectionContainer: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      padding: theme.spacing(7.5),
      gap: theme.spacing(4),
    },
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(6)}px ${theme.spacing(2)}px`,
    },
    alignItems: 'center',
  },
  purpleSectionText: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'center',
    },
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    color: theme.palette.common.white,
    maxWidth: '650px',
  },
  purpleSectionCardRowContainer: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      maxWidth: '1000px',
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      alignContent: 'center',
      gap: theme.spacing(2),
      flexWrap: 'wrap',
      justifyContent: 'center',
      paddingTop: theme.spacing(3.5),
    },
    alignItems: 'center',
    width: '100%',
  },
  purpleSectionCard: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(3)}px ${theme.spacing(1.5)}px`,
      maxWidth: '215px',
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      width: `calc(50% - ${theme.spacing(1)}px)`,
      padding: `${theme.spacing(3)}px ${theme.spacing(1.5)}px`,
      height: '290px',
    },
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    gap: theme.spacing(0.5),
  },
  purpleSectionCardIcon: {
    width: theme.spacing(6),
    height: 'auto',
  },
  accountingSectionContainer: {
    display: 'flex',
    backgroundColor: theme.palette.common.white,
    width: '100%',
  },
  accountingSectionContent: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      maxWidth: '1000px',
      padding: `${theme.spacing(3)}px 0px ${theme.spacing(3)}px 0px`,
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: `${theme.spacing(4)}px ${theme.spacing(2)}px`,
      gap: theme.spacing(4),
    },
    width: '100%',
    margin: 'auto',
  },
  videoRoot: {
    width: '100%',
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
    alignItems: 'center',
    margin: 'auto',
  },
  videoWrapper: {
    maxWidth: '450px',
    width: '100%',
    aspectRatio: '16 / 9',
    justifySelf: 'flex-start',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  accountingSectionLeftContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '50%',
    },
    gap: theme.spacing(2),
    flexShrink: 0,
  },
  purpleText: {
    color: theme.palette.primary.light,
  },
  accountingSectionCard: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1.5),
    gap: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
  },
  accountingSectionCardIcon: {
    width: theme.spacing(4),
    height: 'auto',
    alignSelf: 'flex-start',
  },
  accountingSectionCardText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
  },
  captionSmall: {
    fontSize: '12px',
    color: theme.palette.text.primary,
  },
  paymentsSectionContainer: {
    padding: `${theme.spacing(7.5)}px 0px`,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
}));
